import React from 'react';
import { Cards } from './Cards';

const ListJobVacancyData = () => {
    return (
        <>
            <div className='w-full border-b border-solid border-stone-200'>
                <h1 className='px-4 py-4 text-5xl sm:text-xl md:text-2xl lg:text-3xl font-bold'>
                    List Job Vacancy
                </h1>
                <div className="mx-4 my-4 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2-xl:grid-cols-4 3-xl:grid-cols-5 gap-4">
                    <Cards />
                </div>
            </div>
        </>
    )
}

export default ListJobVacancyData